"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConsoleLogParams = require("./ConsoleLogParams");
Object.keys(_ConsoleLogParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConsoleLogParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConsoleLogParams[key];
    }
  });
});
var _ErrorRestResponse = require("./ErrorRestResponse");
Object.keys(_ErrorRestResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorRestResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorRestResponse[key];
    }
  });
});
var _GenericRestResponse = require("./GenericRestResponse");
Object.keys(_GenericRestResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericRestResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GenericRestResponse[key];
    }
  });
});
var _GetTranslationsOptions = require("./GetTranslationsOptions");
Object.keys(_GetTranslationsOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetTranslationsOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GetTranslationsOptions[key];
    }
  });
});
var _GetUrlOptionsMethod = require("./GetUrlOptionsMethod");
Object.keys(_GetUrlOptionsMethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetUrlOptionsMethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GetUrlOptionsMethod[key];
    }
  });
});
var _HttpMethod = require("./HttpMethod");
Object.keys(_HttpMethod).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HttpMethod[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HttpMethod[key];
    }
  });
});
var _ToIndexed = require("./ToIndexed");
Object.keys(_ToIndexed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ToIndexed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToIndexed[key];
    }
  });
});
var _UrlOptions = require("./UrlOptions");
Object.keys(_UrlOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UrlOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UrlOptions[key];
    }
  });
});
//# sourceMappingURL=index.js.map